// import React, { useEffect, useState, useRef } from "react";
// import { useParams } from "react-router-dom";
// import { getWithTokenAPI, putAPI, postWithoutTokenAPI } from "../../utils/Api";
// import ReactQuill from 'react-quill';
// import { modules, formats } from "../../utils/QuillConfig";
// import Select from 'react-select';
// import { useNavigate } from "react-router-dom"

// const BlogManagementUpdate = () => {
//     const { id } = useParams();
//     const token = localStorage.getItem("token");
//     const quillRef = useRef(null);
//     let navigate = useNavigate()

//     // Main form state
//     const [editForm, setEditForm] = useState({
//         title: "",
//         subtitle: "",
//         description: "",
//         images: [],
//         blog_status: "published",
//         tags: [],
//         categories: [],
//         read_time: "",
//         created_by: "",
//         __v: 0,
//         Approval_status: "Approval"
//     });

//     // UI and loading states
//     const [btnviwe, setbtnviwe] = useState(true);
//     const [isLoading, setIsLoading] = useState(false);

//     // Options for dropdowns
//     const [tags, setTags] = useState([]);
//     const [categories, setCategories] = useState([]);

//     // Image previews
//     const [previewImages, setPreviewImages] = useState([]);

//     // Fetch initial data
//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 setIsLoading(true);

//                 // Fetch blog data
//                 const blogRes = await getWithTokenAPI(token, `/blog/find-particular?_id=${id}`);
//                 if (blogRes?.data) {
//                     setEditForm(blogRes.data);
//                     // Set image previews if images exist
//                     if (blogRes.data.images && blogRes.data.images.length > 0) {
//                         setPreviewImages(blogRes.data.images);
//                     }
//                 }

//                 // Fetch tags and categories
//                 const [tagsRes, catRes] = await Promise.all([
//                     getWithTokenAPI(token, "/tag/find-all"),
//                     getWithTokenAPI(token, "/category/find-all")
//                 ]);

//                 if (tagsRes?.statusCode === 200) {
//                     setTags(tagsRes.data.tags.map(tag => ({
//                         value: tag._id,
//                         label: tag.name
//                     })));
//                 }

//                 if (catRes?.statusCode === 200) {
//                     setCategories(catRes.data.categories.map(category => ({
//                         value: category._id,
//                         label: category.category_name
//                     })));
//                 }
//             } catch (error) {
//                 console.error("Error fetching data:", error);
//             } finally {
//                 setIsLoading(false);
//             }
//         };

//         fetchData();
//     }, [id, token]);

//     // Blog service functions
//     const BlogService = {
//         update: async (token, blogData) => {
//             return await putAPI(token, "/blog/update", blogData, true);
//         }
//     };

//     const handleUpdateBlog = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         try {
//             const blogData = {
//                 ...editForm,
//                 images: previewImages // Use the preview images as the final images
//             };

//             const response = await BlogService.update(token, blogData);
//             if (response?.statusCode === 200 || response?.success) {
//                 alert("Blog updated successfully");
//                 navigate("/admin/blogmanagement")
//                 setbtnviwe(true);
//             } else {
//                 alert("Failed to update blog: " + (response?.message || ""));
//             }
//         } catch (error) {
//             alert("Error updating blog: " + error.message);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleEditInputChange = (e) => {
//         setbtnviwe(false);
//         const { name, value } = e.target;
//         setEditForm(prev => ({ ...prev, [name]: value }));
//     };

//     const handleEditDescriptionChange = (value) => {
//         setbtnviwe(false);
//         setEditForm(prev => ({ ...prev, description: value }));
//     };

//     const handleEditTagsChange = (selectedOptions) => {
//         setbtnviwe(false);
//         setEditForm(prev => ({
//             ...prev,
//             tags: selectedOptions ? selectedOptions.map(option => option.value) : []
//         }));
//     };

//     const handleEditCategoriesChange = (selectedOptions) => {
//         setbtnviwe(false);
//         setEditForm(prev => ({
//             ...prev,
//             categories: selectedOptions ? selectedOptions.map(option => option.value) : []
//         }));
//     };

//     const handleImageChange = async (e) => {
//         setbtnviwe(false);
//         const files = Array.from(e.target.files);

//         if (files.length === 0) return;

//         const formData = new FormData();
//         files.forEach(file => {
//             formData.append('files', file);
//         });
//         formData.append('path', 'media/');

//         try {
//             const response = await postWithoutTokenAPI('/files/upload', formData);
//             if (response.error) {
//                 throw new Error(response.error);
//             }

//             // Get the uploaded file URLs
//             const uploadedUrls = response.data.map(item => item.file_url);

//             // Update both preview images and form images
//             setPreviewImages(prev => [...prev, ...uploadedUrls]);
//             setEditForm(prev => ({
//                 ...prev,
//                 images: [...prev.images, ...uploadedUrls]
//             }));

//         } catch (error) {
//             console.error('Error uploading images:', error);
//             alert('Failed to upload images. Please try again.');
//         }
//     };

//     const removeImage = (index) => {
//         setbtnviwe(false);
//         const newImages = [...previewImages];
//         newImages.splice(index, 1);
//         setPreviewImages(newImages);
//         setEditForm(prev => ({
//             ...prev,
//             images: newImages
//         }));
//     };

//     // Helper function to get selected options for dropdowns
//     const getSelectedOptions = (options, values) => {
//         if (!values || !options) return [];
//         return options.filter(option => values.includes(option.value));
//     };

//     return (
//         <form onSubmit={handleUpdateBlog}>
//             <div className="text-center">
//                 <h5 className="modal-title">Edit Blog</h5>
//             </div>
//             <div className="modal-body mt-4">
//                 <div className="row">
//                     <div className="col-md-6 mb-3">
//                         <label className="form-label">Title*</label>
//                         <input
//                             type="text"
//                             className="form-control"
//                             name="title"
//                             value={editForm.title}
//                             onChange={handleEditInputChange}
//                             required
//                         />
//                     </div>

//                     <div className="col-md-6 mb-3">
//                         <label className="form-label">Subtitle</label>
//                         <input
//                             type="text"
//                             className="form-control"
//                             name="subtitle"
//                             value={editForm.subtitle}
//                             onChange={handleEditInputChange}
//                         />
//                     </div>

//                     <div className="col-12 mb-3">
//                         <label className="form-label">Description*</label>
//                         <ReactQuill
//                             ref={quillRef}
//                             theme="snow"
//                             value={editForm.description}
//                             onChange={handleEditDescriptionChange}
//                             modules={modules}
//                             formats={formats}
//                             className="quill-editor"
//                             style={{ height: '100px', marginBottom: '40px' }}
//                         />
//                     </div>

//                     <div className="col-md-6 mb-3">
//                         <label className="form-label">Read Time (minutes)*</label>
//                         <input
//                             type="number"
//                             className="form-control"
//                             name="read_time"
//                             value={editForm.read_time}
//                             onChange={handleEditInputChange}
//                             required
//                             min="1"
//                         />
//                     </div>

//                     <div className="col-md-6 mb-3">
//                         <label className="form-label">Status*</label>
//                         <select
//                             className="form-select"
//                             name="blog_status"
//                             value={editForm.blog_status}
//                             onChange={handleEditInputChange}
//                             required
//                         >
//                             <option value="published">Published</option>
//                             <option value="draft">Draft</option>
//                         </select>
//                     </div>

//                     <div className="col-md-6 mb-3">
//                         <label className="form-label">Tags</label>
//                         <Select
//                             isMulti
//                             options={tags}
//                             value={getSelectedOptions(tags, editForm.tags)}
//                             onChange={handleEditTagsChange}
//                             className="basic-multi-select"
//                             classNamePrefix="select"
//                         />
//                     </div>

//                     <div className="col-md-6 mb-3">
//                         <label className="form-label">Categories</label>
//                         <Select
//                             isMulti
//                             options={categories}
//                             value={getSelectedOptions(categories, editForm.categories)}
//                             onChange={handleEditCategoriesChange}
//                             className="basic-multi-select"
//                             classNamePrefix="select"
//                         />
//                     </div>

//                     <div className="col-12 mb-3">
//                         <label className="form-label">Images</label>
//                         <input
//                             type="file"
//                             className="form-control"
//                             multiple
//                             onChange={handleImageChange}
//                             name="images"
//                             accept="image/*"
//                         />
//                         <div className="d-flex flex-wrap mt-2">
//                             {previewImages.map((img, index) => (
//                                 <div key={index} className="me-2 mb-2" style={{ width: '100px', position: 'relative' }}>
//                                     <img
//                                         src={img}
//                                         alt={`Preview ${index}`}
//                                         className="img-thumbnail"
//                                         style={{ width: '100%', height: '100px', objectFit: 'cover' }}
//                                     />
//                                     <button
//                                         type="button"
//                                         className="btn btn-danger btn-sm"
//                                         style={{
//                                             position: 'absolute',
//                                             top: '0',
//                                             right: '0',
//                                             padding: '0.1rem 0.3rem'
//                                         }}
//                                         onClick={() => removeImage(index)}
//                                     >
//                                         ×
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="modal-footer">
//                 <button
//                     type="button"
//                     className="btn btn-secondary"
//                     onClick={() => window.history.back()}
//                 >
//                     Cancel
//                 </button>
//                 <button
//                     type="submit"
//                     className="btn btn-success"
//                     disabled={btnviwe || isLoading}
//                 >
//                     {isLoading ? "Updating..." : "Update Blog"}
//                 </button>
//             </div>
//         </form>
//     );
// };

// export default BlogManagementUpdate;


import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Material-UI Imports
import {
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    FormControl,
    InputLabel,
    Select as MuiSelect,
    MenuItem,
    Grid,
    CircularProgress,
    IconButton,
} from "@mui/material";

// Material-UI Icons
import {
    Edit as EditIcon,
    Article as ArticleIcon,
    AccessTime as AccessTimeIcon,
    Category as CategoryIcon,
    Label as LabelIcon,
    Publish as PublishIcon,
    Drafts as DraftsIcon,
    Close as CloseIcon,
    AddPhotoAlternate as AddPhotoAlternateIcon,
} from "@mui/icons-material";

import Select from 'react-select';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getWithTokenAPI, putAPI, postWithoutTokenAPI } from "../../utils/Api";
import { modules, formats } from "../../utils/QuillConfig";
import { useNavigate } from "react-router-dom";
import { Create as CreateIcon, } from "@mui/icons-material";
import { FaAngleLeft } from "react-icons/fa";
// Colors (retained for consistency)
const primaryGreen = "#DC3545";
const lightGreen = "#ffe5e5";
const darkGreen = "#b02a37";

const BlogManagementUpdate = () => {
    const { id } = useParams();
    const token = localStorage.getItem("token");
    const quillRef = useRef(null);
    let navigate = useNavigate();

    const [editForm, setEditForm] = useState({
        title: "",
        subtitle: "",
        description: "",
        images: [],
        blog_status: "published",
        tags: [],
        categories: [],
        read_time: "",
        created_by: "",
        __v: 0,
        Approval_status: "Approval"
    });

    const [btnviwe, setbtnviwe] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [tags, setTags] = useState([]);
    const [categories, setCategories] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);

                const blogRes = await getWithTokenAPI(token, `/blog/find-particular?_id=${id}`);
                if (blogRes?.data) {
                    setEditForm(blogRes.data);
                    if (blogRes.data.images && blogRes.data.images.length > 0) {
                        setPreviewImages(blogRes.data.images);
                    }
                } else {
                    toast.error("Failed to load blog data.");
                }

                const [tagsRes, catRes] = await Promise.all([
                    getWithTokenAPI(token, "/tag/find-all"),
                    getWithTokenAPI(token, "/category/find-all")
                ]);

                if (tagsRes?.statusCode === 200) {
                    setTags(tagsRes.data.tags.map(tag => ({
                        value: tag._id,
                        label: tag.name
                    })));
                } else {
                    toast.error("Failed to load tags: " + (tagsRes?.message || ""));
                }

                if (catRes?.statusCode === 200) {
                    setCategories(catRes.data.categories.map(category => ({
                        value: category._id,
                        label: category.category_name
                    })));
                } else {
                    toast.error("Failed to load categories: " + (catRes?.message || ""));
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Error fetching blog details.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [id, token]);

    const BlogService = {
        update: async (token, blogData) => {
            return await putAPI(token, "/blog/update", blogData, true);
        }
    };

    const handleUpdateBlog = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const blogData = {
                ...editForm,
                images: previewImages
            };
            const response = await BlogService.update(token, blogData);
            if (response?.statusCode === 200 || response?.success) {
                toast.success("Blog update successfully!", { autoClose: 1000 })
                setTimeout(() => {
                    navigate("/backoffice/blogmanagement");
                }, 1000);
                setbtnviwe(true);
            } else {
                toast.error("Failed to update blog: " + (response?.message || "Unknown error"));
            }
        } catch (error) {
            toast.error("Error updating blog: " + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleEditInputChange = (e) => {
        setbtnviwe(false);
        const { name, value } = e.target;
        setEditForm(prev => ({ ...prev, [name]: value }));
    };

    const handleEditDescriptionChange = (value) => {
        setbtnviwe(false);
        setEditForm(prev => ({ ...prev, description: value }));
    };

    const handleEditTagsChange = (selectedOptions) => {
        setbtnviwe(false);
        setEditForm(prev => ({
            ...prev,
            tags: selectedOptions ? selectedOptions.map(option => option.value) : []
        }));
    };

    const handleEditCategoriesChange = (selectedOptions) => {
        setbtnviwe(false);
        setEditForm(prev => ({
            ...prev,
            categories: selectedOptions ? selectedOptions.map(option => option.value) : []
        }));
    };

    const handleImageChange = async (e) => {
        setbtnviwe(false);
        const files = Array.from(e.target.files);

        if (files.length === 0) return;

        setIsLoading(true);

        const formData = new FormData();
        files.forEach(file => {
            formData.append('files', file);
        });
        formData.append('path', 'media/blogs/');

        try {
            const response = await postWithoutTokenAPI('/files/upload', formData);
            if (response.error) {
                throw new Error(response.error);
            }

            const uploadedUrls = response.data.map(item => item.file_url);

            setPreviewImages(prev => [...prev, ...uploadedUrls]);
            setEditForm(prev => ({
                ...prev,
                images: [...prev.images, ...uploadedUrls]
            }));
            toast.success("Image uploaded successfully!");

        } catch (error) {
            console.error('Error uploading images:', error);
            toast.error('Failed to upload images. Please try again.');
        } finally {
            setIsLoading(false);
            e.target.value = null;
        }
    };

    const removeImage = (urlToDelete) => {
        setbtnviwe(false);
        setPreviewImages(prev => prev.filter(url => url !== urlToDelete));
        setEditForm(prev => ({
            ...prev,
            images: prev.images.filter(url => url !== urlToDelete)
        }));
        toast.info("Image removed from selection.");
    };

    const getSelectedOptions = (options, values) => {
        if (!values || !options) return [];
        return options.filter(option => values.includes(option.value));
    };

    if (isLoading && editForm.title === "") {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3, width: "100%" }}>
            <ToastContainer position="top-center" autoClose={1500} />
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: "space-between",
                mb: 3,
                p: 2,
                backgroundColor: lightGreen,
                borderRadius: 2,
                borderLeft: `5px solid ${primaryGreen}`
            }}>
                <Box sx={{ display: "flex", alignItems: 'center', }}>
                    <CreateIcon sx={{ color: primaryGreen, fontSize: 40, mr: 2 }} />
                    <Box>
                        <Typography variant="h4" component="h1" sx={{ color: primaryGreen, fontWeight: 'bold' }}>
                            Edit Blog Post
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            Update the details of this blog entry.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: 'center', cursor: 'pointer', color: primaryGreen }}>
                    <FaAngleLeft />
                    <Typography variant="h6" sx={{ fontWeight: 'bold', width: '150px' }}
                        onClick={() => navigate("/backoffice/blogmanagement")}>
                        back
                    </Typography>
                </Box>
            </Box>


            <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
                <form onSubmit={handleUpdateBlog} className="blogform">
                    <Grid container className="row row-cols-3 align-items-center">
                        <Grid item sx={{ mb: 3 }}>
                            <InputLabel className="mb-2">Title <span className="text-danger">*</span></InputLabel>
                            <TextField
                                fullWidth
                                name="title"
                                value={editForm.title}
                                onChange={handleEditInputChange}
                                required
                                InputProps={{
                                    startAdornment: (
                                        <ArticleIcon sx={{ mr: 1, color: 'action.active' }} />
                                    ),
                                }}
                            />
                        </Grid>

                        {/* Subtitle */}
                        <Grid item sx={{ mb: 3 }}>
                            <InputLabel className="mb-2">Subtitle <span className="text-danger">*</span></InputLabel>

                            <TextField
                                fullWidth
                                name="subtitle"
                                value={editForm.subtitle}
                                onChange={handleEditInputChange}
                                InputProps={{
                                    startAdornment: (
                                        <ArticleIcon sx={{ mr: 1, color: 'action.active' }} />
                                    ),
                                }}
                            />
                        </Grid>

                        {/* Read Time */}
                        <Grid item sx={{ mb: 3 }}>
                            <InputLabel className="mb-2">Read Time <span className="text-danger">*</span></InputLabel>
                            <TextField
                                fullWidth
                                type="number"
                                name="read_time"
                                value={editForm.read_time}
                                // onChange={handleEditInputChange}
                                onChange={(e) => {
                                    const value = Number(e.target.value);
                                    if (value >= 1 || e.target.value === "") {
                                        handleEditInputChange(e);
                                    }
                                }}
                                required

                            />
                        </Grid>

                        {/* Status */}
                        <Grid item sx={{ mb: 1 }} className="col-6">
                            <InputLabel id="blog-status-label" className="mb-2">Status <span className="text-danger">*</span></InputLabel>
                            <FormControl fullWidth required>
                                <MuiSelect
                                    labelId="blog-status-label"
                                    name="blog_status"
                                    value={editForm.blog_status}
                                    onChange={handleEditInputChange}
                                    startAdornment={
                                        editForm.blog_status === "published" ?
                                            <PublishIcon sx={{ mr: 1, color: primaryGreen }} /> :
                                            <DraftsIcon sx={{ mr: 1, color: '#e65100' }} />
                                    }>
                                    <MenuItem value="published">Published</MenuItem>
                                    <MenuItem value="draft">Unpublished</MenuItem>
                                </MuiSelect>
                            </FormControl>
                        </Grid>

                        {/* Description (ReactQuill) */}
                        <Grid item className="col-12" sx={{ mb: 3 }}  >
                            <Typography variant="subtitle1" gutterBottom sx={{ mt: 1, mb: 1, color: 'text.secondary' }}>
                                Description <span className="text-danger">*</span>
                            </Typography>
                            <Box sx={{
                                borderRadius: '4px',
                                '&:hover': {
                                    borderColor: primaryGreen, // Mimic TextField hover border
                                },
                                // Apply focus styles directly
                                '& .ql-editor:focus-within': { // Target the editor content when focused
                                    borderColor: primaryGreen,
                                    boxShadow: `0 0 0 1px ${primaryGreen}`,
                                },
                                transition: 'border-color 0.2s ease-out, box-shadow 0.2s ease-out',
                                '.ql-toolbar': {
                                    borderTopLeftRadius: '4px',
                                    borderTopRightRadius: '4px',
                                    borderBottom: '1px solid #c4c4c4 !important', // Ensure toolbar bottom border
                                },
                                '.ql-container': {
                                    borderBottomLeftRadius: '4px',
                                    borderBottomRightRadius: '4px',
                                    borderTop: 'none !important', // Remove top border as toolbar has it
                                },
                            }}>
                                <ReactQuill
                                    ref={quillRef}
                                    theme="snow"
                                    value={editForm.description}
                                    onChange={handleEditDescriptionChange}
                                    modules={modules}
                                    formats={formats}
                                    required
                                    style={{ height: "200px" }}

                                />
                            </Box>
                            {/* This empty grid item provides spacing below quill editor */}
                        </Grid>
                        {/* Images */}
                        <Grid item xs={12} sx={{ mb: 3, mt: 5 }}>
                            <Typography variant="subtitle1" gutterBottom sx={{ mb: 1, color: 'text.secondary' }}>
                                Blog Image <span className="text-danger">*</span>
                            </Typography>
                            <Button
                                component="label"
                                variant="outlined"
                                startIcon={<AddPhotoAlternateIcon />}
                                sx={{ mb: 2, borderColor: primaryGreen, color: primaryGreen, '&:hover': { borderColor: darkGreen } }}
                                disabled={isLoading}
                            >
                                Upload  Image
                                <input
                                    type="file"
                                    hidden
                                    multiple
                                    onChange={handleImageChange}
                                    accept="image/*"
                                />
                            </Button>
                            {isLoading && (
                                <CircularProgress size={24} sx={{ ml: 2, color: primaryGreen }} />
                            )}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
                                {previewImages.map((imgUrl, index) => (
                                    <Box key={index} sx={{ position: 'relative', width: 100, height: 100, border: '1px solid #ddd', borderRadius: 1, overflow: 'hidden' }}>
                                        <img
                                            src={imgUrl}
                                            alt={`Preview ${index}`}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                        <IconButton
                                            size="small"
                                            sx={{
                                                position: 'absolute',
                                                top: 2,
                                                right: 2,
                                                backgroundColor: 'rgba(255, 0, 0, 0.7)',
                                                color: 'white',
                                                '&:hover': { backgroundColor: 'red' },
                                            }}
                                            onClick={() => removeImage(imgUrl)}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>

                    </Grid>
                    {/* Action Buttons */}
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
                        <Button
                            variant="outlined"
                            onClick={() => navigate("/backoffice/blogmanagement")}
                            sx={{ color: primaryGreen, borderColor: primaryGreen, '&:hover': { borderColor: primaryGreen } }}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
                            disabled={btnviwe || isLoading}
                            sx={{
                                backgroundColor: primaryGreen,
                                color: 'white',
                                '&:hover': { backgroundColor: darkGreen }
                            }}
                        >
                            {isLoading ? "Updating..." : "Update Blog"}
                        </Button>
                    </Grid>
                </form>
            </Paper>
        </Box >
    );
};

export default BlogManagementUpdate;